// Jump to the chat replies a source is cited in, and flash them once (right
// panel v2, "Cited in N replies in the chat"). An impure DOM effect at the
// shell edge, the transcript sibling of the editor's `revealElement`: it reads
// the rows' `data-entry-id`, scrolls the transcript (only) to the first and
// replays a one-shot CSS flash (RightPanel.css). Nothing it touches outlives the animation or
// carries domain meaning, so there is no state to project.

import { centerInScrollParent } from "../../../components/scrollParent.js";

const FLASH = "bilda-rp-flash";

export const revealChatReplies = (entryIds: readonly string[]): void => {
    const rows = entryIds.flatMap((id) => {
        const row = document.querySelector<HTMLElement>(
            `.bilda-chat-message[data-entry-id="${CSS.escape(id)}"]`,
        );
        return row === null ? [] : [row];
    });
    const first = rows[0];
    if (first !== undefined) centerInScrollParent(first);
    rows.forEach((row) => {
        row.classList.remove(FLASH);
        // Force a reflow so re-adding the class replays the animation.
        row.getBoundingClientRect();
        row.classList.add(FLASH);
        row.addEventListener(
            "animationend",
            () => row.classList.remove(FLASH),
            {
                once: true,
            },
        );
    });
};
